import { useState } from "react";
import HeaderComponent from "../components/HeaderComponent";
import Device from "../pages/Device";
import Firmware from "../pages/Firmware";
import ConfiguredDevices from "./Automation";
import Users from "./Users";
import DeviceHardware from "../components/DeviceHardware/DeviceHardware";
import GatewayPage from "./GatewayPage";


function MainPage(props) {

  const [page, setPage] = useState("DEVICES");
  const loadPages = (value) => {
    setPage(value);
  }
  return (
    <>
      <HeaderComponent loadPages={(value) => loadPages(value)} logOut={props.loginFailure} toggleTheme={props.toggleTheme} mode={props.mode} />
      <span />
      {page === "DEVICES" && <Device />}
      {page === "FIRMWARE" && <Firmware />}
      {page === "USERS" && <Users />}
      {page === "CONFIGURED DEVICES" && <ConfiguredDevices />}
      {page === "DEVICE HARDWARE" && <DeviceHardware />}
      {page === "GATEWAY" && <GatewayPage />}
    </>
  );
}

export default MainPage;